import { invokeApi } from "../../bl_libs/invokeApi";

export const account_deleted = async (data) => {
  let requestObj = {
    path: "api/customer/delete_customer_from_web",
    method: "POST",
    headers: {
    //   "x-sh-auth": localStorage.getItem("token"),
    },
  };
  requestObj["postData"] = data;

  return invokeApi(requestObj);
};